import { IProvince } from 'interfaces'
import { useEffect, useState } from 'react'
import { registryService } from 'services'

function useProvince(setError?: (error: any) => void) {
  const [province, setProvince] = useState<IProvince[]>([])

  useEffect(() => {
    const controller = registryService.getProvince(setProvince, setError)
    return () => controller.abort()
  }, [setError])

  return province
}

export default useProvince
